import React from 'react';
import { useLocation } from 'react-router-dom';

import { Layout } from 'components';

export default function RootPage() {
  const location = useLocation();

  return (
    <Layout>
      <div className="container has-text-centered">
        <h1 className="title">404 No page found</h1>
        <h2 className="subtitle">{location.pathname}</h2>
      </div>
    </Layout>
  );
}
